/* APP */

export const APP_NAME = "Alakoze";
export const APP_SHORT_NAME = "Alakoze";
export const APP_DESCRIPTION = "Connect, share, and discover on Alakoze.";

/* API */

export const URL = "http://192.168.12.192:3001";

/* MEDIA */

export const media_base_url = "http://192.168.12.192:3001/uploads";

export const MAX_PROFILE_IMAGE_SIZE = 5 * 1024 * 1024;
export const MAX_COVER_PHOTOS = 3;
export const MAX_VIDEO_DURATION = 15;

export const IMAGE_TYPES = ["image/jpeg", ["image/jpg"], "image/png", "image/webp"];
export const VIDEO_TYPES = ["video/mp4", "video/webm"];
export const AUDIO_TYPES = ["audio/webm", "audio/mp4", "audio/ogg"];

/* PAGINATION */

export const POSTS_PER_PAGE = 10;
export const COMMENTS_PER_PAGE = 20;

/* NAVIGATION */

export const leftSidebarLinks = [
  { imgURL: "/assets/icons/home.svg", route: "/", label: "Feed" },
  { imgURL: "/assets/icons/wallpaper.svg", route: "/followers", label: "Followers" },
  { imgURL: "/assets/icons/people.svg", route: "/followings", label: "Followings" },
  { imgURL: "/assets/icons/save.svg", route: "/saved", label: "Saved" },
];

export const bottombarLinks = [
  { imgURL: "/assets/icons/home.svg", route: "/", label: "Home" },
  { imgURL: "/assets/icons/wallpaper.svg", route: "/explore", label: "Explore" },
  { imgURL: "/assets/icons/bookmark.svg", route: "/saved", label: "Saved" },
  { imgURL: "/assets/icons/like.svg", route: "/liked", label: "Liked" },
];